import moment from "moment/moment";
import "../pagination/pagination.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from "../pagination/pagination";
import LeaseApiService from "../../services/apiService";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import React, { useState, useEffect, Component } from "react";
import { AsyncPaginate } from 'react-select-async-paginate';
import "ag-grid-community/styles/ag-theme-quartz.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import Select from "react-select";
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import { getUserName } from "../../../Redux/selecters";
const REPORT_URL = process.env.REACT_APP_REPORTS_URL
const RevenueRental = () => {
    const apiService = new LeaseApiService();
    const username = useSelector(getUserName);
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [unitList, setUnitList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState();
    const [unitClass, setUnitClass] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [FilterTab, setFilterTab] = useState(true);
    const ITEMS_PER_PAGE = 100
    const [propertyList, setPropertyList] = useState([]);
    const [leaseTypeList, setLeaseTypeList] = useState([]);
    const [formData, setFormData] = useState({
        property: "",
        tenantId: "",
        from: "",
        unitNo: "",
        tenantName: "",
        to: "",
        unitClass: "",
        leaseType: "",
        type: "",
    })
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const sortByPropertyUnit = (data) => {
        return [...(data || [])].sort((a, b) => {
            const propertyCompare = (a?.propertyName || "").localeCompare(b?.propertyName || "", undefined, { numeric: true, sensitivity: "base" });
            if (propertyCompare !== 0) return propertyCompare;
            return (a?.unitNo || "").toString().localeCompare((b?.unitNo || "").toString(), undefined, { numeric: true, sensitivity: "base" });
        });
    };
    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        let todate = formatDate(today)
        setFormData((prev) => ({ ...prev, to: todate, from: todate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRAgreeSearchCustomers,LRAgreeSearchType,LRAgreeSearchLeaseType,LRSearchUnitClass');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const sortedProperties = [...(res?.data?.dropdowns?.LRAgreeSearchProperties || [])].sort((a, b) =>
                (a?.text || "").localeCompare(b?.text || "", undefined, { numeric: true, sensitivity: "base" })
            );
            setPropertyList(sortedProperties)
            setTypeList(res?.data?.dropdowns?.LRAgreeSearchType)
            setTanentList(res?.data?.dropdowns?.LRAgreeSearchCustomers)
            setLeaseTypeList(res?.data?.dropdowns?.LRAgreeSearchLeaseType)
            setUnitClass(res?.data?.dropdowns?.UnitClass)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("leaseRevenueRental.FromDate", formData?.from || todate);
            params.append("leaseRevenueRental.ToDate", formData?.to || todate);
            params.append("leaseRevenueRental.PropertyNo", formData?.property?.value?.value || "All");
            params.append("leaseRevenueRental.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseRevenueRental.CustomerNo", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
            params.append("leaseRevenueRental.Unitclass", formData?.unitClass?.label || "All");
            params.append("leaseRevenueRental.LeaseType", formData?.leaseType?.label || "All");
            params.append("leaseRevenueRental.Type", formData?.type?.label || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_REVENUE", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(sortByPropertyUnit(res?.data?.result));
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
                setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("leaseRevenueRental.FromDate", formData?.from || todate);
            params.append("leaseRevenueRental.ToDate", formData?.to || todate);
            params.append("leaseRevenueRental.PropertyNo", formData?.property?.value?.value || "All");
            params.append("leaseRevenueRental.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseRevenueRental.CustomerNo", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
            params.append("leaseRevenueRental.Unitclass", formData?.unitClass?.label || "All");
            params.append("leaseRevenueRental.LeaseType", formData?.leaseType?.label || "All");
            params.append("leaseRevenueRental.Type", formData?.type?.label || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_REVENUE", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(sortByPropertyUnit(result));
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const decimalFormatter = (params) => {
        return (parseFloat(params.value) || 0).toFixed(3);
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        { headerName: "Lease No", field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120, pinned: "left", },
        { headerName: "Lease Type", field: "leaseType", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Property Name", field: "propertyName", filter: true, floatingFilter: true, suppressMovable: true, width: 200, },
        { headerName: "Unit No", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120 },
        { headerName: "Tenant ID", field: "customerNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Tenant Name", field: "customerName", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Lease Amount", field: "leaseAmount", filter: true, floatingFilter: true, valueFormatter: decimalFormatter, suppressMovable: true, width: 100, },
        { headerName: "Due Date", field: "dueDate", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "Invoice No", field: "leaseNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120, },
        { headerName: "Payment Type", field: "installment", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Invoice Amount", field: "dueAmount", filter: true, floatingFilter: true, valueFormatter: decimalFormatter, suppressMovable: true, width: 100, },
        { headerName: "Received", field: "amountPaid", filter: true, floatingFilter: true, valueFormatter: decimalFormatter, suppressMovable: true, width: 100, },
        { headerName: "Actual Revenue", field: "revenue", filter: true, floatingFilter: true, valueFormatter: decimalFormatter, suppressMovable: true, width: 100, },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setUnitList([])
        setFormData({
            property: "",
            tenantId: "",
            from: todate,
            unitNo: "",
            tenantName: "",
            to: todate,
            unitClass: "",
            leaseType: "",
            type: "",
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items)
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === "tenantId") {
            setFormData(prev => ({ ...prev, [name]: value, tenantName: { label: value?.value?.text, value: value?.value } }));
        } else if (name === "tenantName") {
            setFormData(prev => ({ ...prev, [name]: value, tenantId: { label: value?.value?.value, value: value?.value } }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return ""; // keep this if you want 0 to be empty

        // Check if value is a date string in ISO format
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");


        const columns = [
            { header: "Lease No", dataKey: "leaseNo", width: 50 },
            { header: "Lease Type", dataKey: "leaseType", width: 50 },
            { header: "Property Name", dataKey: "propertyName", width: 100 },
            { header: "Unit No", dataKey: "unitNo", width: 50 },
            { header: "Tenant ID", dataKey: "customerNo", width: 100 },
            { header: "Tenant Name", dataKey: "customerName", width: 50 },
            { header: "Lease Amount", dataKey: "leaseAmount", width: 60 },
            { header: "Due Date", dataKey: "dueDate", width: 60 },
            { header: "Invoice No", dataKey: "leaseNo", width: 50 },
            { header: "Payment Type", dataKey: "installment", width: 50 },
            { header: "Invoice Amount", dataKey: "dueAmount", width: 50 },
            { header: "Received", dataKey: "amountPaid", width: 80 },
            { header: "Actual Revenue", dataKey: "revenue", width: 60 },
        ];

        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Revenue Rental Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated unit: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [columns.map(col => col.header)],
            body: exportData.map(row =>
                columns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Revenue_rental_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const columns = [
            { header: "Lease No", dataKey: "leaseNo", width: 50 },
            { header: "Lease Type", dataKey: "leaseType", width: 50 },
            { header: "Property Name", dataKey: "propertyName", width: 100 },
            { header: "Unit No", dataKey: "unitNo", width: 50 },
            { header: "Tenant ID", dataKey: "customerNo", width: 100 },
            { header: "Tenant Name", dataKey: "customerName", width: 50 },
            { header: "Lease Amount", dataKey: "leaseAmount", width: 60 },
            { header: "Due Date", dataKey: "dueDate", width: 60 },
            { header: "Invoice No", dataKey: "leaseNo", width: 50 },
            { header: "Payment Type", dataKey: "installment", width: 50 },
            { header: "Invoice Amount", dataKey: "dueAmount", width: 50 },
            { header: "Received", dataKey: "amountPaid", width: 80 },
            { header: "Actual Revenue", dataKey: "revenue", width: 60 },
        ];

        const sumKeys = ["dueAmount", "amountPaid", "revenue"];
        const decimalKeys = ["leaseAmount"];

        const excelData = exportData.map(item => {
            const row = {};
            columns.forEach(col => {
                if (sumKeys.includes(col.dataKey)) {
                    row[col.header] = parseFloat(item[col.dataKey]) || 0;
                } else if (decimalKeys.includes(col.dataKey)) {
                    row[col.header] = (parseFloat(item[col.dataKey]) || 0).toFixed(3);
                } else {
                    row[col.header] = normalizeValue(item[col.dataKey]);
                }
            });
            return row;
        });

        const totalRow = {};
        columns.forEach(col => {
            totalRow[col.header] = "";
        });
        totalRow[columns[9].header] = "Total";
        columns.forEach(col => {
            if (sumKeys.includes(col.dataKey)) {
                totalRow[col.header] = exportData
                    .reduce((sum, item) => sum + (parseFloat(item[col.dataKey]) || 0), 0);
            }
        });
        excelData.push(totalRow);

        const worksheet = XLSX.utils.json_to_sheet(excelData);

        worksheet["!cols"] = columns.map(col => {
            const maxDataLen = excelData.reduce((max, row) => {
                const cellLen = row[col.header] ? String(row[col.header]).length : 0;
                return Math.max(max, cellLen);
            }, col.header.length);
            return { wch: maxDataLen + 2 };
        });

        const headerRowNum = 1;
        const totalRowNum = excelData.length + 1;
        columns.forEach((col, i) => {
            const colRef = XLSX.utils.encode_col(i);
            const headerCell = worksheet[`${colRef}${headerRowNum}`];
            if (headerCell) headerCell.s = {
                font: { bold: true, color: { rgb: "FFFFFF" } },
                fill: { fgColor: { rgb: "6E5199" } },
            };
            const totalCell = worksheet[`${colRef}${totalRowNum}`];
            if (totalCell) totalCell.s = { font: { bold: true } };

            if (sumKeys.includes(col.dataKey)) {
                for (let rowNum = headerRowNum + 1; rowNum <= totalRowNum; rowNum++) {
                    const cellRef = `${colRef}${rowNum}`;
                    const cell = worksheet[cellRef];
                    if (cell && cell.t === "n") cell.z = "0.000";
                }
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Rental Report");
        XLSX.writeFile(workbook, "Revenue_rental_Report.xlsx", { cellStyles: true });
    }
    const showExcel = () => {
        if (rowData?.length > 0) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const today = new Date();
            let todate = formatDate(today)
            const newTab = window.open("", "_blank");

            if (!newTab) {
                alert("Please allow popups for this site.");
                return;
            }

            if (newTab) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REPORT_URL;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "ReportName", value: "REVENUERENTALREPORT" },
                    { name: "FromDate", value: formData?.from || todate },
                    { name: "ToDate", value: formData?.to || todate },
                    { name: "PropertyNo", value: formData?.property?.value?.value || "ALL" },
                    { name: "UnitNo", value: formData?.unitNo?.label || "ALL" },
                    { name: "CustomerId", value: formData?.tenantId?.label || formData?.tenantName?.value?.value || "ALL" },
                    { name: "UnitClass", value: formData?.unitClass?.label || "ALL" },
                    { name: "LeaseType", value: formData?.leaseType?.label || "ALL" },
                    { name: "Type", value: formData?.type?.label || "ALL" },
                    { name: "downloadType", value: "EXCEL" },
                    { name: "UserName", value: username },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        } else {
            toast.warning("No record found")
        }
    }
    const loadOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant ID</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantId}
                                    loadOptions={loadOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantId", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantName}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantName", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">To</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit Class</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitClass}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitClass', value: selectedOption })}
                                    options={unitClass?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseType', value: selectedOption })}
                                    options={leaseTypeList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.type}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                                    options={typeList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50"                                    >
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Revenue Rental List</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                            <button className="btn btn-secondary" onClick={showExcel}>
                                Show Report
                            </button>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default RevenueRental;
